export default "__VITE_PUBLIC_ASSET__26a1a6f5__"